import type { Bytes } from "@pdfking/structs"
import { Collect, UInt8Merge } from "@pdfking/tfunc"

import type { StreamInput } from "#public"

import { StreamToIterable } from "./StreamToIterable"

/** Drains whatever a caller has into the bytes it adds up to.
 *
 * Where a stream stops being one: a hash is of the whole thing, a size is the
 * sum, and a wasm entry point takes a buffer. Everybody collects the same way,
 * which is why nobody does it — and why nobody has to build a blob to
 * concatenate with.
 *
 * `bytes` is the total where the caller already knows it — a stored entry says
 * how big it is before anybody reads it — which spares the merge a pass over
 * the chunks to add their lengths up. Leaving it out is for the other case: a
 * write, whose size is what the collecting is for.
 *
 * @example
 * ```ts
 * import { UInt8Collect } from "@pdfking/io"
 *
 * const bytes = await UInt8Collect(response.body)
 * ```
 */
export const UInt8Collect = (value: StreamInput, bytes?: Bytes): Promise<Uint8Array<ArrayBuffer>> =>
  Collect(StreamToIterable(value)).then(chunks => UInt8Merge(chunks, bytes))
